import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';
import {PlatformPill} from './PlatformPill';
import {CHANNEL_INFO_BY_CHANNEL} from '../channels/channels';

const STATUS_DEFS = [
    {key: 'linked', dotColor: null, i18nKey: 'agency_accounts_filter.status_linked'},
    {key: 'unlinked', dotColor: '#F7E9CE', i18nKey: 'agency_accounts_filter.status_unlinked'},
    {key: 'ignored', dotColor: '#D3CBFF', i18nKey: 'agency_accounts_filter.status_ignored'},
];


class AccountsFilterBarClass extends Component {

    getCountsByChannel() {
        const counts = {};
        const {clientAdAccounts, clientStores, unlinkedAdAccounts, ignoredAdAccounts} = this.props.accounts;
        const selectedStatuses = this.props.selectedStatuses;

        const countChannel = (channel) => {
            if (!CHANNEL_INFO_BY_CHANNEL[channel]) return;
            counts[channel] = (counts[channel] || 0) + 1;
        };

        if (selectedStatuses.has('linked')) {
            if (clientAdAccounts) {
                clientAdAccounts.forEach(a => countChannel(a.channel));
            }
            if (clientStores) {
                clientStores.forEach(a => countChannel(a.channel));
            }
        }
        if (selectedStatuses.has('unlinked')) {
            if (unlinkedAdAccounts) {
                unlinkedAdAccounts.forEach(a => countChannel(a.channel));
            }
        }
        if (selectedStatuses.has('ignored')) {
            if (ignoredAdAccounts) {
                ignoredAdAccounts.forEach(data => countChannel(data.ad_account.channel));
            }
        }

        return counts;
    }

    getCountsByStatus() {
        const {clientAdAccounts, clientStores, unlinkedAdAccounts, ignoredAdAccounts} = this.props.accounts;
        const {selectedPlatforms} = this.props;
        const matchesPlatform = (ch) => selectedPlatforms.size === 0 || selectedPlatforms.has(ch);
        return {
            linked: (clientAdAccounts || []).filter(a => matchesPlatform(a.channel)).length
                  + (clientStores || []).filter(a => matchesPlatform(a.channel)).length,
            unlinked: (unlinkedAdAccounts || []).filter(a => matchesPlatform(a.channel)).length,
            ignored: (ignoredAdAccounts || []).filter(d => matchesPlatform(d.ad_account.channel)).length,
        };
    }

    hasActiveFilters() {
        return this.props.selectedPlatforms.size > 0
            || this.props.searchQuery.trim() !== ''
            || this.props.selectedStatuses.size < 3;
    }

    render() {
        const {t, selectedPlatforms, selectedStatuses, searchQuery, onPlatformToggle, onSearchChange, onStatusToggle, onClearAll} = this.props;
        const counts = this.getCountsByChannel();
        const channels = Object.keys(counts).sort((a, b) => counts[b] - counts[a]);
        const statusCounts = this.getCountsByStatus();

        if (channels.length === 0 && !this.hasActiveFilters()) return null;

        return (
            <div className="accounts-filter-bar" role="search" aria-label={t('agency_accounts_filter.filter_by_platform')}>
                <div className="accounts-filter-bar__search">
                    <FaIcon iconName="search" />
                    <input
                        type="search"
                        placeholder={t('agency_accounts_filter.search_placeholder')}
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                </div>
                <div className="accounts-filter-bar__pills" aria-live="polite">
                    {channels.map(channel => (
                        <PlatformPill
                            key={channel}
                            channel={channel}
                            count={counts[channel]}
                            isSelected={selectedPlatforms.has(channel)}
                            onClick={onPlatformToggle}
                        />
                    ))}
                </div>
                {this.hasActiveFilters() && (
                    <button
                        className="accounts-filter-bar__clear"
                        onClick={onClearAll}
                    >
                        {t('agency_accounts_filter.clear_filters')}
                    </button>
                )}
                <div className="accounts-filter-bar__status-chips">
                    {STATUS_DEFS.filter(({key}) => statusCounts[key] > 0 || selectedStatuses.has(key))
                      .map(({key, dotColor, i18nKey}) => (
                        <button key={key}
                            className={`accounts-filter-bar__status-chip ${selectedStatuses.has(key) ? '--active' : ''}`}
                            onClick={() => onStatusToggle(key)}>
                            {dotColor && <span className="accounts-filter-bar__status-dot" style={{backgroundColor: dotColor}} />}
                            <span>{t(i18nKey)}</span>
                            <span className="accounts-filter-bar__status-count">{statusCounts[key]}</span>
                        </button>
                    ))}
                </div>
            </div>
        );
    }
}

export const AccountsFilterBar = withTranslation()(AccountsFilterBarClass);
